<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_914_1225)">
        <path d="M24 4H0V20H24V4Z" fill="#00247D" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.50056 12.0003L-0.769043 5.15387L0.769086 2.84668L12 10.334L23.231 2.84668L24.7691 5.15387L14.4995 12.0003L24.7691 18.8467L23.231 21.1539L12 13.6666L0.769086 21.1539L-0.769043 18.8467L9.50056 12.0003Z"
            fill="white" />
        <mask id="mask0_914_1225" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="4"
            width="24" height="16">
            <path d="M12 12H24V20L12 12ZM12 12V20H0L12 12ZM12 12H0V4L12 12ZM12 12V4H24L12 12Z"
                fill="white" />
        </mask>
        <g mask="url(#mask0_914_1225)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.3347 12.0001L-0.51239 4.76868L0.51243 3.23145L12 10.8898L23.4876 3.23145L24.5124 4.76868L13.6654 12.0001L24.5124 19.2314L23.4876 20.7687L12 13.1103L0.51243 20.7687L-0.51239 19.2314L10.3347 12.0001Z"
                fill="#CF142B" />
        </g>
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.68925 9.68925V4H14.3108V9.68925H24V14.3108H14.3108V20H9.68925V14.3108H0V9.68925H9.68925Z"
            fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M10.6135 10.6135V4H13.3865V10.6135H24V13.3865H13.3865V20H10.6135V13.3865H0V10.6135H10.6135Z"
            fill="#CF142B" />
    </g>
    <defs>
        <clipPath id="clip0_914_1225">
            <rect width="24" height="24" fill="white" />
        </clipPath>
    </defs>
</svg>
    
